import React from 'react';
import { useDrag } from 'react-dnd';
import { ItemTypes } from './DraggableActionItem';

const DraggablePlanetAction = ({ 
  children, 
  actionType, 
  payload, 
  setDraggedItem,
  updatePreviewState
}) => {
  // Set up the drag source
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.PLANET_ACTION,
    item: () => {
      // Notify parent about the dragged item
      const draggedItem = { 
        type: ItemTypes.PLANET_ACTION, 
        actionType,
        payload
      };
      setDraggedItem(draggedItem);
      return draggedItem;
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    }),
    end: (item, monitor) => {
      // Clear dragged item when drag ends
      setDraggedItem(null);
      // Clear preview state regardless of where the drag ended
      updatePreviewState(null);
    }
  });

  return (
    <div 
      ref={drag} 
      style={{ 
        opacity: isDragging ? 0.5 : 1,
        cursor: 'grab'
      }}
      className="draggable-planet-action inline-block"
    >
      {children}
    </div>
  );
};

export default DraggablePlanetAction;
